import { InputContext } from '../InputContext';
import { Typo } from '../../../ui/typo.ts';
import { css } from '@emotion/css';
import { Colors } from '../../../ui/vars';
import React from 'react';

interface Props {
    text: React.ReactNode;
    context: InputContext;
    key?: string;
}

export function InputError({ text, context }: Props) {
    return (
        <div
            className={css([
                {
                    ...Typo.caption,
                    height: '20px',
                    fontSize: '12px',
                    paddingBottom: '4px',
                    cursor: 'default',
                },
                context === InputContext.regular && {
                    color: Colors.error,
                },
                context === InputContext.form && {
                    color: Colors.error,
                },
                context === InputContext.inverted && {
                    color: Colors.error_b,
                },
            ])}
            data-context={InputContext[context]}
        >
            {text}
        </div>
    );
}

export const Factory = (
    props: Props,
    ...children: React.ReactNode[]
): React.ReactElement => React.createElement(InputError, props, ...children);
